import urls from '@/networkRequests/apiClient/endpoints'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getAllTripsForAdminApi } from './getAllTripsForAdmin.api'
import getAllTripsForAdminInitialState from './getAllTripsForAdmin.initialState'
import { GetAllTripsForAdminErrorResponse, GetAllTripsForAdminRequestPayload } from './getAllTripsForAdmin.types'

export const getAllTripsForAdmin = createAsyncThunk(
  urls.admin.getAllTripsForAdmin,
  async (payload: GetAllTripsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getAllTripsForAdminApi(request)

      if (onSuccess) {
        onSuccess()
      }

      return response
    } catch (error) {
      return rejectWithValue(error as ApiErrorResponse)
    }
  }
)

const getAllTripsForAdminSlice = createSlice({
  name: 'getAllTripsForAdmin',
  initialState: getAllTripsForAdminInitialState,
  reducers: {
    resetGetAllTripsForAdmin: () => getAllTripsForAdminInitialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllTripsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllTripsForAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(getAllTripsForAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as GetAllTripsForAdminErrorResponse
        errorHandler.handleApiError(action.payload as GetAllTripsForAdminErrorResponse, undefined, true)
      })
  }
})

export const getAllTripsForAdminActions = {
  ...getAllTripsForAdminSlice.actions,
  getAllTripsForAdmin
}

export default getAllTripsForAdminSlice.reducer
